import React from "react";
import MensajeAyuda from "../modal-ayuda-registro/modal-ayuda-registro.cmpt";

export default class Header extends React.Component {
  state = {
    posicion: 0,
    showModalAyuda: false,
    tipoModalAyuda: "",
  };

  activModal = () => {
    const btnAyuda = localStorage.getItem("btnAyuda");

    if(btnAyuda !== undefined && btnAyuda === "true"){
      this.setState({ showModalAyuda: true, tipoModalAyuda: "regresar"});
    } else {
      window.open("https://www.gnp.com.mx/", "_self");
      
    } 
  }

  cierraModal = e => {
    this.setState({
      showModalAyuda: !this.state.showModalAyuda 
    });
  }

  render() {
    return (
      <div>
        <MensajeAyuda onClose={this.cierraModal} show={this.state.showModalAyuda} typeModal={this.state.tipoModalAyuda}></MensajeAyuda>

        <div className="navContent" style={{borderBottom: '1px solid #002e71'}}>
          <div className="navMain">
            <div className="navHeader layout-row layout-align-space-between-end">
              <div className="layout-padding">
                <a onClick={this.activModal}>
                  <img src={require("../img/icons-gnp/logo-GNP.svg")}  style={{width: '150px', height: '48px'}} />
                </a>
              </div>
              <div className="layout-padding">
                <img src={require("../img/icons-gnp/logo_vivir_increible.svg")} style={{width: '180px'}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/home/header.cmpt.js